module.exports = __webpack_public_path__ + "static/media/button.6f68dabd.png";